import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import v from 'voca';
import Grid from '@material-ui/core/Grid';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import intl from 'react-intl-universal';
import { MESSAGEORDER_TYPES } from 'src/constants/constants';
import classNames from 'classnames';
import Hidden from '@material-ui/core/Hidden';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import Spinner from 'src/ui/library/Spinner/Spinner';
import ListItemPres from './ListItemPres';

export default function ListPres({
  isDraftView,
  messages,
  meta,
  selectMessage,
  checkBoxHandler,
  filters,
  isCaseMessages,
  isComposeView,
  isDelete,
  editHandler,
  checked,
  changeSortOrder,
  showConfirm,
  isMobile,
  selectedMenu,
  menuHandler,
  switchView,
  isDashboardMessages,
  dashboardSelectMessage,
  dashboardStoreSelectedMessageId,
  // isMessagingLoading,
  isDefaultOldView,
  isFilterLoaded,
  isMessageLoaded,
  resetFilterLoader,
  resetMessageLoader,
  refreshUnReadMessage,
}) {
  const arrowClass = classNames({
    'icon md': true,
    'icon-disabled': isDelete,
  });

  const navClassName = classNames({
    'nav-bar case-nav': isCaseMessages,
    'list-header-nav': !isCaseMessages,
  });

  const listHeaderClassName = classNames({
    'list-header case-list-header': isCaseMessages,
    'list-header': !isCaseMessages,
  });

  // React.useEffect(() => {
  //   resetFilterLoader();
  //   resetMessageLoader();
  // }, [!isMessagingLoading]);

  return (
    <Fragment>
      {!isDashboardMessages && (
        <header className={listHeaderClassName}>
          <Hidden smUp>
            <Fragment>
              <Grid container spacing={0}>
                <Grid item sm={isDelete ? false : 4} xs={isDelete ? false : 4}>
                  {!isDelete && (
                    <div className="list-link-wrapper" onClick={menuHandler}>
                      <KeyboardArrowLeftIcon className="toolbar-icon fl" />
                      <span className="list-link fl">{intl.get('messaging.list.mailboxes')}</span>
                    </div>
                  )}
                </Grid>

                <Grid item sm={isDelete ? false : 4} xs={isDelete ? false : 4}>
                  {!isDelete && (
                    <div className="list-link-wrapper">
                      <span className="list-link black">{v.titleCase(selectedMenu)}</span>
                    </div>
                  )}
                </Grid>

                <Grid item sm={isDelete ? 5 : 4} xs={isDelete ? 5 : 4}>
                  <div className="list-link-wrapper">
                    {!isDelete && (
                      <span className="list-link" onClick={editHandler}>
                        {intl.get('messaging.list.editmessages')}
                      </span>
                    )}
                    {isDelete && (
                      <span className={classNames({ 'list-link': true, fl: isMobile })} onClick={editHandler}>
                        {intl.get('messaging.list.cancel')}
                      </span>
                    )}
                    {!!checked.length && (
                      <span className="list-link" onClick={showConfirm}>
                        {intl.get('messaging.list.delete')}
                      </span>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Fragment>
          </Hidden>

          <Hidden xsDown>
            <Fragment>
              {!isCaseMessages && (
                <nav className={isDefaultOldView ? navClassName : 'refresh-arrow'}>
                  {filters.sortDirection === MESSAGEORDER_TYPES.ASC ? (
                    <ArrowUpward
                      className={arrowClass}
                      onClick={() => {
                        !isDelete && changeSortOrder(MESSAGEORDER_TYPES.DESC);
                      }}
                    />
                  ) : (
                    <ArrowDownward
                      className={arrowClass}
                      onClick={() => {
                        !isDelete && changeSortOrder(MESSAGEORDER_TYPES.ASC);
                      }}
                    />
                  )}
                </nav>
              )}
              {isDelete && (
                <span className="list-link" onClick={editHandler}>
                  {intl.get('messaging.list.cancel')}
                </span>
              )}
              {!!checked.length && (
                <span className="list-link" onClick={showConfirm}>
                  {intl.get('messaging.list.delete')}
                </span>
              )}
            </Fragment>
          </Hidden>
        </header>
      )}

      <div className="list-container">
        {messages &&
          messages.map((item, index) => (
            <ListItemPres
              isComposeView={isComposeView}
              isDashboardMessages={isDashboardMessages}
              isDraftView={isDraftView}
              key={item.id}
              details={item}
              index={index}
              selectedIndex={meta.selectedIndex}
              selectMessage={selectMessage}
              checkBoxHandler={checkBoxHandler}
              isDelete={isDelete}
              switchView={switchView}
              dashboardSelectMessage={dashboardSelectMessage}
              dashboardStoreSelectedMessageId={dashboardStoreSelectedMessageId}
              selectedMenu={selectedMenu}
              resetFilterLoader={resetFilterLoader}
              resetMessageLoader={resetMessageLoader}
              refreshUnReadMessage={refreshUnReadMessage}
            />
          ))}

        {messages && messages.length === 0 && isFilterLoaded === true && isMessageLoaded === true && (
          <div className="no-results">{intl.get('messaging.list.noResults')}</div>
        )}

        {messages && messages.length === 0 && (isFilterLoaded === false || isMessageLoaded === false) && (
          <div className="no-results">
            <Spinner size={70} />
          </div>
        )}
      </div>
    </Fragment>
  );
}

ListPres.propTypes = {
  messages: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
  selectMessage: PropTypes.func.isRequired,
  checkBoxHandler: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
  editHandler: PropTypes.func.isRequired,
  checked: PropTypes.array.isRequired,
  showConfirm: PropTypes.func.isRequired,
};
